export default "__VITE_PUBLIC_ASSET__9fd71c5d__"